import { useCallback, useEffect, useState } from "react"
import { useNotificationStore } from "../stores/use-notification-store.js"
import { NotificationContext } from "./notification-context.js"

/**
 * @component NotificationProvider
 * @description Provider global para o sistema de notificações.
 * Gerencia o estado do sidebar e expõe helpers para toda a aplicação.
 */
export function NotificationProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false)

    const notifications = useNotificationStore((s) => s.notifications)
    const addNotification = useNotificationStore((s) => s.addNotification)
    const removeNotification = useNotificationStore((s) => s.removeNotification)
    const clearExpired = useNotificationStore((s) => s.clearExpired)

    useEffect(() => {
        clearExpired()
        const interval = setInterval(clearExpired, 60_000)
        return () => clearInterval(interval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const open = useCallback(() => setIsOpen(true), [])
    const close = useCallback(() => setIsOpen(false), [])
    const toggle = useCallback(() => setIsOpen((v) => !v), [])

    return (
        <NotificationContext.Provider value={{
            isOpen,
            count: notifications.length,
            notifications,
            open,
            close,
            toggle,
            addNotification,
            removeNotification,
        }}>
            {children}
        </NotificationContext.Provider>
    )
}
